import {
    HttpResponse,
    TransactionModel,
    QueryModel,
    RequestParams,
    TransactionModelIEnumerableApiResultSuccess,
    TransactionModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class TransactionsDataService implements CrudService<TransactionModel, TransactionModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationTransaction(query, params).then((req: any) => req.data.returnValue);
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<TransactionModel>): Promise<CrudListResponse<TransactionModel>> {
        return ApiService.api.getTransactionBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<TransactionModel>> {
        return ApiService.api.getTransactionById(id, params);
    }

    create(item: TransactionModel, params?: RequestParams): Promise<CrudResponse<TransactionModel>> {
        return ApiService.api.insertTransaction(item, params);
    }

    update(item: TransactionModel, params?: RequestParams): Promise<TransactionModel> {
        return ApiService.api.updateTransaction(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<TransactionModel> {
        return ApiService.api.patchTransaction(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<TransactionModel>): Promise<CrudListResponse<TransactionModel>> {
        return ApiService.api.deleteTransactions(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<TransactionModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
